import { Card } from 'antd'

export default function ContentCard({ children, loading, title }) {
  return (
    <Card bordered={false} loading={loading} title={title} className="content-card">
      {children}
    </Card>
  )
}
